module.exports = __webpack_public_path__ + "static/media/TabonBakerySite 2.e8f123cf.png";